import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { AccessProfileService } from "src/app/domain/services/access-profile.service";
import { EnviromentsService } from "src/app/domain/services/enviroments.service";
import { LoginService } from "src/app/domain/services/login.service";
import { NotificationComponent } from "src/app/ui/notification/notification.component";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html"
})
export class HeaderComponent implements OnInit {
	@ViewChild("notification") refNotification: NotificationComponent;

	private token: string;
	private decoded: any;
	hasPermission = false;
	email: string;
	loadEnviromentsObj: any = [];
	constructor(
		private router: Router,
		private loginService: LoginService,
		private cookieService: CookieService,
		private accessProfileService: AccessProfileService,
		private enviromentsService: EnviromentsService
	) {}

	@Output() buttonToggle = new EventEmitter();

	async ngOnInit() {
		this.token = localStorage.getItem("token");
		this.decoded = this.loginService.decodeToken(this.token);
		this.email = this.decoded.email;
		this.loadEnviroments();
		await this.accessProfileService
			.getProfiliesClaimLink("Consulta%20e%20Cadastro%20de%20Propostas%20e%20Emiss%C3%B5es")
			.then(actions => {
				if (!!actions?.data?.item1?.actions) {
					var action = actions.data.item1.actions.toString();
					if (Array.isArray(actions) && actions.length > 1) {
						this.hasPermission = actions.filter(f => f == "post").length ? true : false;
					} else {
						var actionsSplited = action.split(",");
						this.hasPermission = actionsSplited.filter(f => f == "post").length ? true : false;
					}
				}
			});
	}

	loadEnviroments() {
		this.enviromentsService.GeAlltEnviroments().subscribe(res => {
			this.loadEnviromentsObj = res;
		});
	}

	logOut() {
		localStorage.removeItem("token");
		localStorage.removeItem("profileClaim");
		localStorage.removeItem("notification");

		const isSecure = environment.urlWorkflow.indexOf("https://") == 0;
		this.cookieService.deleteAll("", `${environment.urlWorkflow.replace(/^https?\:\/\//i, "")}`, isSecure, "None");

		this.router.navigate(["/login"]);
	}

	perfil() {
		this.router.navigate(["/meu-perfil/perfil"]);
	}

	toggle(): void {
		this.buttonToggle.emit();
	}

	redirectToProposal() {
		if (this.router.url.includes("/propostas/consultar")) {
			this.router.navigateByUrl("/propostas/consultar");
		}
		this.router.navigate(["/propostas/consultar"], { state: { fromButton: true } });
	}
}
